import React, { FC, useState, useEffect } from 'react'
import { Container, Box, Typography, Link, Divider } from '@mui/material'
import { routes } from 'config'

import { useOktaAuth } from '@okta/okta-react'
import constants from '../../../../../utils/constants'
import useStyles from './base-layout-header-style'
import { useLocation } from 'react-router-dom'
import appConfig from 'config/app-config'

const BaseLayoutHeader: FC = () => {
  const location = useLocation()

  const data: any =
    location.pathname === '/mfa'
      ? sessionStorage.getItem('mfa_article')
      : sessionStorage.getItem('login_article')
  const [needHelpArticle, setNeedHelpArticle] = useState<any>({})
  const getLoginArticle = () => {
    setNeedHelpArticle(JSON.parse(data))
  }
  const [showExpirePasswordLink, setShowExpirePasswordLink] =
    useState<boolean>(false)
  const [showImpersonateLink, setShowImpersonateLink] = useState<boolean>(false)
  const { authState, oktaAuth } = useOktaAuth()
  const { classes } = useStyles()
  useEffect(() => {
    if (process.env.REACT_APP_IMPERSONATE_LOGIN !== 'true') {
      getLoginArticle()
    } else {
      if (authState?.isAuthenticated) {
        setShowImpersonateLink(true)
        const accessTokenData = oktaAuth.token.decode(
          authState?.accessToken.accessToken,
        )
        const userGroups = accessTokenData.payload.groups
        setShowExpirePasswordLink(
          userGroups.includes(constants.OKTA_GROUPS.EXPIRE_PASSWORD_ACCESS),
        )
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, location.pathname])

  useEffect(() => {
    if (process.env.REACT_APP_MULTI_LOGIN === 'true') {
      setShowImpersonateLink(false)
    }
  }, [data, location.pathname])

  let topRightSubtitleContent = needHelpArticle?.ctaText && (
    <Link href={needHelpArticle.ctaLink} target="_blank" rel="noopener">
      {needHelpArticle.ctaText}
    </Link>
  )
  if (
    process.env.REACT_APP_IMPERSONATE_LOGIN === 'true' &&
    !appConfig.isMultiLogin
  ) {
    topRightSubtitleContent = <span>Staff Login</span>
  }

  if (appConfig.isMultiLogin) {
    topRightSubtitleContent = (
      <span>
        Multi Login
        {authState?.isAuthenticated && (
          <>
            {' | '}
            <Link
              href="https://multilogin.dev.brightmls.com/logout"
              rel="noopener"
            >
              Logout
            </Link>
          </>
        )}
      </span>
    )
  }

  let expirePasswordLink = (
    <Link href="/expire-password/" rel="noopener">
      Expire Password
    </Link>
  )
  let impersonateLink = (
    <Link href="/impersonate/" rel="noopener">
      Impersonate
    </Link>
  )

  return (
    <Container maxWidth="lg">
      <Box
        display="flex"
        marginX={[0, 2, 3]}
        paddingX={[0, 2, 3]}
        marginBottom={3}
      >
        <Box marginTop={2.8} marginLeft={[-1, -2, 0]}>
          <Link href={routes.defaultRedirection} target="_self">
            <img
              src={`${process.env.PUBLIC_URL}/static/images/bright.svg`}
              height="52"
              alt="Bright MLS"
            />
          </Link>
        </Box>
        <Box
          flexGrow={1}
          marginLeft={[3, 9.5, 14]}
          className={classes.expirePasswordImpersonateStaffLoginContainer}
        >
          <Box
            flexGrow={1}
            className={classes.expirePasswordImpersonateContainer}
          >
            {showExpirePasswordLink && (
              <Box className={classes.expirePasswordLink}>
                <Typography
                  variant="subtitle1"
                  component="span"
                  children={expirePasswordLink}
                />
              </Box>
            )}
            {showImpersonateLink && (
              <Box textAlign="left" marginBottom={0.8} top="-5px">
                <Typography
                  variant="subtitle1"
                  component="span"
                  children={impersonateLink}
                />
              </Box>
            )}
          </Box>
          <Box className={classes.staffLogin}>
            <Typography
              variant="subtitle1"
              component="span"
              children={topRightSubtitleContent}
            />
          </Box>
          <Divider />
        </Box>
      </Box>
    </Container>
  )
}

export default BaseLayoutHeader
